'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCaptcha = getCaptcha;
exports.verifyCaptcha = verifyCaptcha;

var _requestOlympics = require('@ali/request-olympics');

var _requestOlympics2 = _interopRequireDefault(_requestOlympics);

var _request = require('../adapter/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *判断返回值
 * @param {Object} res 返回值
 * @returns Promise.reject or Promise.resolve
 */
function resErrorJudge(res) {
  if (!res || !res.success) {
    return Promise.reject(res);
  }
  return Promise.resolve(res.data);
}

function getCaptcha(_ref) {
  var _ref$phone = _ref.phone,
      phone = _ref$phone === undefined ? '' : _ref$phone,
      _ref$sequenceNo = _ref.sequenceNo,
      sequenceNo = _ref$sequenceNo === undefined ? '' : _ref$sequenceNo,
      _ref$fieldName = _ref.fieldName,
      fieldName = _ref$fieldName === undefined ? '' : _ref$fieldName,
      _ref$codeLen = _ref.codeLen,
      codeLen = _ref$codeLen === undefined ? '' : _ref$codeLen;

  return _requestOlympics2.default.get((0, _request.urlPrefix)() + '/form/captcha/code/send', {
    params: {
      phone: phone,
      sequenceNo: sequenceNo,
      fieldName: fieldName
      // codeLen
    }
  }).then(resErrorJudge);
}

function verifyCaptcha(_ref2) {
  var _ref2$phone = _ref2.phone,
      phone = _ref2$phone === undefined ? '' : _ref2$phone,
      _ref2$sequenceNo = _ref2.sequenceNo,
      sequenceNo = _ref2$sequenceNo === undefined ? '' : _ref2$sequenceNo,
      _ref2$code = _ref2.code,
      code = _ref2$code === undefined ? '' : _ref2$code,
      _ref2$cid = _ref2.cid,
      cid = _ref2$cid === undefined ? '' : _ref2$cid,
      _ref2$checksum = _ref2.checksum,
      checksum = _ref2$checksum === undefined ? '' : _ref2$checksum,
      _ref2$fieldName = _ref2.fieldName,
      fieldName = _ref2$fieldName === undefined ? '' : _ref2$fieldName;

  return _requestOlympics2.default.post((0, _request.urlPrefix)() + '/form/captcha/code/verify', {
    phone: phone,
    sequenceNo: sequenceNo,
    code: code,
    cid: cid,
    checksum: checksum,
    fieldName: fieldName
  }).then(resErrorJudge);
}